import CommonAPIService from "src/serviceHandlers/commonHandler";

export function createCrudService(resource, customRoutes = [], router) {
  const api = new CommonAPIService(router);
  const base = `/api/${resource}`;

  const service = {
    list:    (params) => api.getCall(`${base}`, params),
    getById: id => api.getCall(`${base}/${id}`),
    create:  payload => api.postCall(`${base}`, payload),
    update:  (id, payload) => api.putCall(`${base}/${id}`, payload),
    delete:  id => api.deleteCall(`${base}/${id}`),
  };

  customRoutes.forEach(({ method, path, handlerName }) => {
    service[handlerName] = (...args) => {
      // Handle routes with parameters like /:id/something
      if (path.includes("/:id")) {
        const [id, payload] = args;
        const finalPath = path.replace("/:id", `/${id}`);
        const fullUrl = `${base}${finalPath.startsWith("/") ? finalPath : `/${finalPath}`}`;
        return api[method.toLowerCase() + "Call"](fullUrl, payload);
      } else {
        // For routes without parameters, use the first argument as payload
        const fullUrl = `${base}${path.startsWith("/") ? path : `/${path}`}`;
        return api[method.toLowerCase() + "Call"](fullUrl, args[0]);
      }
    };
  });

  return service;
}
